'use client';
import { isString } from '@s7/utils';

var getAutoHeightDuration = function(height) {
    if (!height || isString(height)) {
        return 0;
    }
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
};

export { getAutoHeightDuration };
